import axiosInstance from '../../config/axiosConfig';
import { urlValorImpacto } from '../../config/apiURL';
import { extractArray, extractDataObject } from '../utils/responseHelpers';

// Obtener todos los valores de impacto
export async function getValorImpacto() {
    try {
        const response = await axiosInstance.get(urlValorImpacto);
        return extractArray(response);
    } catch (error) {
        console.error('Error fetching valor impacto:', error);
        throw error;
    }
}

// Obtener un valor de impacto por ID
export async function getValorImpactoById(id) {
    try {
        const response = await axiosInstance.get(`${urlValorImpacto}/${id}`);
        return extractDataObject(response);
    } catch (error) {
        console.error(`Error fetching valor impacto ${id}:`, error);
        throw error;
    }
}

// Crear un nuevo valor de impacto
export async function createValorImpacto(data) {
    try {
        const payload = {
            ...data,
            act_codigo: Number(data?.act_codigo),
            div_codigo: Number(data?.div_codigo),
            vul_codigo: Number(data?.vul_codigo),
            vai_fecha: data?.vai_fecha
                ? new Date(data.vai_fecha).toISOString().split("T")[0]
                : new Date().toISOString().split("T")[0],
            vai_valor: Number(data?.vai_valor ?? 0),
        };

        const response = await axiosInstance.post(urlValorImpacto, payload);
        return extractDataObject(response);
    } catch (error) {
        console.error('Error creating valor impacto:', error);
        throw error;
    }
}

// Actualizar un valor de impacto
export async function updateValorImpacto(id, data) {
    try {
        const payload = {
            ...data,
            act_codigo: Number(data?.act_codigo),
            div_codigo: Number(data?.div_codigo),
            vul_codigo: Number(data?.vul_codigo),
            vai_fecha: data?.vai_fecha
                ? new Date(data.vai_fecha).toISOString().split("T")[0]
                : new Date().toISOString().split("T")[0],
            vai_valor: Number(data?.vai_valor ?? 0),
        };

        const response = await axiosInstance.put(`${urlValorImpacto}/${id}`, payload);
        return extractDataObject(response);
    } catch (error) {
        console.error(`Error updating valor impacto ${id}:`, error);
        throw error;
    }
}

// Eliminar un valor de impacto
export async function deleteValorImpacto(id) {
    try {
        const response = await axiosInstance.delete(`${urlValorImpacto}/${id}`);
        return extractDataObject(response);
    } catch (error) {
        console.error(`Error deleting valor impacto ${id}:`, error);
        throw error;
    }
}